export default __webpack_public_path__ + "static/media/pay-bills-left-col.b7385a86.png";